module.exports = __webpack_public_path__ + "media/slider/Banner-8-c536661e.jpg";